import { AUTHORITIES } from '@app/constants/authorities'
import { LOADING } from '@app/constants/redux-state'
import useLocalization from '@app/hooks/useLocalization'
import { IOrganizationSchedule } from '@app/interfaces/organization/organization-schedule'
import { rolesChecker } from '@app/utils/roles-checker/rolesChecker'
import { setDocumentTitle } from '@app/utils/set-document-title/set-document-title'
import { Card, Table, Tag } from 'antd'
import axios from 'axios'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import OrganizationSchedulesForm from './components/organization-schedule-form/organization-schedule-form'
import { getOrganizationSchedules } from '@app/store/actions/organization-schedule-actions'

interface props {
  _organizationSchedules: IOrganizationSchedule[]
  _state: string
}

const ReferenceBookOrganizationSchedules: React.FC<props> = ({
  _organizationSchedules,
  _state,
}) => {
  const [t] = useTranslation()
  const dispatch = useDispatch()
  const { localizeData } = useLocalization()
  setDocumentTitle(t('institutionSchedule.title'))

  useEffect(() => {
    const source = axios.CancelToken.source()
    if (isEmpty(_organizationSchedules))
      dispatch(
        getOrganizationSchedules(
          { source },
          t('organizationSchedule.errors.load'),
        ),
      )
    return () => {
      source.cancel('Component got unmounted')
    }
  }, [])

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('organizationSchedule.schedule'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('general.status'),
      dataIndex: 'status',
      key: 'status',

      render: (tags) => (
        <>
          {tags.map((tag) => {
            const color = tag === true ? 'green' : 'volcano'
            const text =
              color === 'green' ? t('general.active') : t('general.inActive')
            return (
              <Tag color={color} key={tag}>
                {text}
              </Tag>
            )
          })}
        </>
      ),
    },
    {
      title: t('general.action'),
      key: 'action',
      render: (text, record) =>
        rolesChecker([
          AUTHORITIES.ADMIN,
          AUTHORITIES.ROLE_SETTING_DICTIONARY_EDIT,
        ]) ? (
          <OrganizationSchedulesForm
            edit={true}
            organizationSchedule={record.organizationSchedule}
          />
        ) : null,
    },
  ]

  const data = !isEmpty(_organizationSchedules)
    ? _organizationSchedules.map((organizationSchedule) => {
        return {
          key: organizationSchedule.id,
          id: organizationSchedule.id,
          name: localizeData(organizationSchedule?.data)?.name,
          status: [organizationSchedule.status],
          organizationSchedule: organizationSchedule,
        }
      })
    : []
  return (
    <>
      <Card
        extra={
          rolesChecker([
            AUTHORITIES.ADMIN,
            AUTHORITIES.ROLE_SETTING_DICTIONARY_EDIT,
          ]) ? (
            <OrganizationSchedulesForm />
          ) : null
        }
        title={t('organizationSchedule.title')}>
        <Table
          pagination={false}
          loading={_state === LOADING}
          dataSource={data}
          columns={columns}
        />
      </Card>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    _organizationSchedules: state.organizationSchedule.organizationSchedules,
    _state: state.organizationSchedule.state,
  }
}

export default connect(mapStateToProps)(ReferenceBookOrganizationSchedules)
